<label class="apto-form-control--form-label" for="for">
    <ng-content></ng-content>
</label>